<template>
  <div>
    <ul class="view-type-list mb-2">
      <li v-for="(viewType, index) in viewTypeChoices" :key="viewType.value" class="view-type-choice">
        <button v-if="viewType.value != selectedViewType" type="button" class="btn btn-link" @click="selectViewType(viewType.value)">
          {{ viewType.display }}
        </button>
        <div v-else>
          {{ viewType.display }}
        </div>
        <!-- Add border to each choice that is not the last choice -->
        <!-- It was not clear how to make this work with css only and still support RTL locales -->
        <div v-if="index < viewTypeChoices.length - 1" class="mx-1">
          |
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'

const VIEW_TYPE_ARCHIVE = 'archive'
const VIEW_TYPE_FEED = 'feed'

export default {
  emits: ['view-type-selected'],

  data() {
    return {
      viewTypeChoices: [
        {
          value: VIEW_TYPE_FEED,
          display: this.i18n.t('member.forums.view_types.feed')
        },
        {
          value: VIEW_TYPE_ARCHIVE,
          display: this.i18n.t('member.forums.view_types.archive')
        }]
    }
  },
  computed: mapState({selectedViewType: state => state.viewType}),
  methods: {
    selectViewType(viewType) {
      this.$emit('view-type-selected', viewType)
    }
  }
}
</script>

<style scoped lang="scss">
  .view-type-list {
    list-style: none;
    display: flex;
    align-items: center;
    padding: 0;
  }

  .view-type-choice {
    display: flex;
    align-items: center;

    button.btn-link {
      padding: 0;
    }
  }

</style>
